import React from 'react';
import { Link } from 'react-router-dom';
import { useContent } from '../context/ContentContext';
import './ShopSection.css';

const ShopSection = () => {
  const { content } = useContent();

  return (
    <section className="shop-section" id="shop">
      <div className="shop-grid stagger-container">
        <div className="shop-item stagger-item scale-in smooth-hover">
          <Link to="/shop#presets" className="shop-link">
            <div className="shop-image image-reveal">
              <img
                src={content.shop.presets.image}
                alt={content.shop.presets.title}
              />
            </div>
            <h3>{content.shop.presets.title}</h3>
          </Link>
        </div>
        <div className="shop-item stagger-item scale-in smooth-hover">
          <Link to="/shop#prints" className="shop-link">
            <div className="shop-image image-reveal">
              <img
                src={content.shop.prints.image}
                alt={content.shop.prints.title}
              />
            </div>
            <h3>{content.shop.prints.title}</h3>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ShopSection;

